/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */
import config from 'js-sdk/src/jrs.configs';
import moment from 'moment';
// @ts-ignore
import dateUtils from 'js-sdk/src/common/util/parse/date';
import formatsMappingUtil from './formatsMappingUtil';
import {
    Categorizer,
    Formatter, Options
} from './types';

function momentLocale(value: string): moment.Moment {
    return moment(value).locale(config.userLocale);
}

function convertToIso(value: string) {
    if (/Q1/.test(value)) {
        return value.slice(0, 4).concat('-01-05T01:32:21.196Z');
    }
    if (/Q2/.test(value)) {
        return value.slice(0, 4).concat('-04-05T01:32:21.196Z');
    }
    if (/Q3/.test(value)) {
        return value.slice(0, 4).concat('-07-05T01:32:21.196Z');
    }
    if (/Q4/.test(value)) {
        return value.slice(0, 4).concat('-10-05T01:32:21.196Z');
    }
    if (/^\d{4}$/.test(value)) {
        return value.concat('-01-05T01:32:21.196Z');
    }
    return value;
}

export default {
    format(val: string, format?: string, options?: Options): string {
        if (formatsMappingUtil.isEmpty(val)) {
            return '';
        }
        if (formatsMappingUtil.isOtherNode(val)) {
            return val;
        }
        if (formatsMappingUtil.isTotalNode(val)) {
            return val;
        }
        if (options && (options as Categorizer).categorizer?.indexOf('_only') > 0) return val;
        if (formatsMappingUtil.shouldBeReturnedAsLocalizedDayOfWeek(options)) {
            return formatsMappingUtil.getLocalizedDayOfWeek(val);
        }
        const formatForMoment = formatsMappingUtil.getFormatForMoment(format, options) || dateUtils.fromJavaToMomentDatePattern(format)
        if (formatForMoment) {
            return momentLocale(convertToIso(val)).format(formatForMoment);
        }
        return val;
    }
} as Formatter;
